import { network } from 'services/network';

import { QueryParams } from 'api/mutations/UpdateRiskRegister.mutation';

export const updateRiskRegister = (params: QueryParams) => {
    return network.post('api/bo/updateRiskRegister', params).then((response) => {
        return response.data;
    });
};
